import { VFC } from 'react';
import { useSelector } from 'react-redux';
import { getProductsInCart } from '../../reducks/users/selectors';
import { RootState } from '../../reducks/store/store';
import { ProductInCart } from '../../reducks/users/types';
import { TextDetail } from '../Uikit/TextDetail';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import { BrownButton } from '../Uikit/BrownButton';
import { useNavigate } from "react-router-dom";

type Props = {
  handleDrawerToggle: (e: any) => void;
};


export const HeaderMenus: VFC<Props> = (props) => {

  const selector = useSelector((state: RootState) => state);
  const navigate = useNavigate();
  
  // カート内商品
  let productsInCart = getProductsInCart(selector);
  
  const subtotal = productsInCart.reduce(
    (sum: number, product: ProductInCart) => (sum += product.price * product.quantity),
    0
  );

  return (
    <>
      <AppBar position="fixed" style={{ color: 'black', backgroundColor: "white" }} sx={{ top: 'auto', bottom: 0 }}>
        <Toolbar>
          <TextDetail
              label={'合計 (税込) '}
              value={`¥${subtotal.toLocaleString()}`}
          />
          <Box sx={{ flexGrow: 1 }} />
          <BrownButton label={'注文へ進む'} onClick={() => navigate('/order/confirm')} />
        </Toolbar>
      </AppBar>
    </>
  );
};